// extracted by mini-css-extract-plugin
module.exports = {"widgetCodeWrapper":"RetailerWidgetSettings_widgetCodeWrapper__yuoBp"};